export default __webpack_public_path__ + "static/media/blood1.1f2bf03d.png";